// GA4 Analytics utility — fires events only if NEXT_PUBLIC_GA_MEASUREMENT_ID is a real value.
// All calls are safe no-ops when GA is not configured.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

function isGAConfigured(): boolean {
  const id = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
  return (
    typeof id === 'string' &&
    id.trim() !== ''&& !id.includes('your-') &&
    id.startsWith('G-')
  );
}

function track(eventName: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined') return;
  if (!isGAConfigured()) return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params ?? {});
}

// ── Key frontend events ──────────────────────────────────────────────────────

export function trackSignupStarted(method?: string) {
  track('signup_started', { method: method ?? 'email' });
}

export function trackResumeUploaded(fileType?: string) {
  track('resume_uploaded', { file_type: fileType ?? 'unknown' });
}

export function trackResumeAnalyzed(success: boolean, resumeId?: string) {
  track('resume_analyzed', { success, resume_id: resumeId ?? '' });
}

export function trackJobSaved(jobId: string, company?: string) {
  track('job_saved', { job_id: jobId, company: company ?? '' });
}

export function trackApplicationTracked(applicationId: string, method?: string) {
  track('application_tracked', { application_id: applicationId, method: method ?? 'manual' });
}

export function trackAIAssistCreated(workflowId: string, jobId?: string) {
  track('ai_assist_created', { workflow_id: workflowId, job_id: jobId ?? '' });
}

export { isGAConfigured };
